<div class="categories-container">
	<div class="category">
		<p class="title">{{ 'EXTERNALREGISTRATIONFORM.CATEGORIES.PERSONAL' | translate | uppercase }}</p>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="firstName"
						 #firstName="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.FIRSTNAME.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.firstName">
			<mat-error *ngIf="firstName.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="lastName"
						 #lastName="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.LASTNAME.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.lastName">
			<mat-error *ngIf="lastName.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>

		<def-password-input [member]="member"></def-password-input>

		<mat-form-field floatLabel="always">
			<input matInput
						 type="email"
						 name="email"
						 email
						 #email="ngModel"
						 required
						 pattern="^(?!.*decathlon[.]com$).*$"
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.EMAIL.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.email">
			<mat-error *ngIf="email.invalid && !email.errors?.pattern">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
			<mat-error *ngIf="email.errors?.pattern">{{ 'EXTERNALREGISTRATIONFORM.INVALIDPATTERN' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="tel"
						 name="phoneNumber"
						 #phoneNumber="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.PHONENUMBER.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.phoneNumber">
			<mat-error *ngIf="phoneNumber.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="address"
						 #address="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.ADDRESS.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.address">
			<mat-error *ngIf="address.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="addressComplement"
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.ADDRESSCOMPLEMENT.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.addressComplement">
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="zipCode"
						 #zipCode="ngModel"
						 required
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.ZIPCODE.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.zipCode">
			<mat-error *ngIf="zipCode.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<input matInput
						 type="text"
						 name="city"
						 required
						 #city="ngModel"
						 placeholder="{{ 'EXTERNALREGISTRATIONFORM.CITY.PLACEHOLDER' | translate | uppercase }}"
						 [(ngModel)]="member.city">
			<mat-error *ngIf="city.invalid">{{ 'EXTERNALREGISTRATIONFORM.INVALIDVALUE' | translate }}</mat-error>
		</mat-form-field>
		<def-country-input [member]="member"></def-country-input>
	</div>
</div>
